import { Pagination } from '@/domain/entities/Pagination'

export class BulletinData {
  public id: number
  public fileCode: string
  public title: string
  public isActive: boolean
  public isRecommended: boolean
  public Owner: string
  public file: Object
  public imageThumbnail: Object
  public createdAt: string
  public updatedAt: string
  public expireddate: string

  constructor(
    id: number,
    fileCode: string,
    title: string,
    isActive: boolean,
    isRecommended: boolean,
    Owner: string,
    file: Object,
    imageThumbnail: Object,
    createdAt: string,
    updatedAt: string,
    expireddate: string
  ) {
    {
      this.id = id
      this.fileCode = fileCode
      this.title = title
      this.isActive = isActive
      this.isRecommended = isRecommended
      this.Owner = Owner
      this.file = file
      this.imageThumbnail = imageThumbnail
      this.createdAt = createdAt
      this.updatedAt = updatedAt
      this.expireddate = expireddate
    }
  }
}

export class Bulletin {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: BulletinData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: BulletinData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
